import React from 'react'
import logo from "assets/images/logo_white.png";

export default function Logo(props) {
    return (
        <img alt="رواد" src={logo} className="img-logo" />
    )
}